<div class="atm-header" [ngClass]="{ nonProduction: isNonProduction() }">
  <div class="logo-appName mobile-view-hide">
    <i class="csx-logo_csx_notagline"></i>
    <span class="pageName">{{ appShortName }}</span>
    <a class="appName">
      <span class="shortName">{{ appShortName }}</span>
      <span> - </span>
      <span class="longName">{{ appLongName }}</span>
    </a>
  </div>

  <div class="logo-appName mobile-view-show" *ngIf="routeName == 'Authorities'">
    <i class="csx-logo_csx_notagline"></i>
    <span class="pageName">{{ appShortName }}</span>
    <a class="appName">
      <span class="shortName">{{ appShortName }}</span>
      <span> - </span>
      <span class="longName">{{ appLongName }}</span>
    </a>
  </div>

  <div class="logo-appName mobile-view-show" *ngIf="routeName == 'History'">
    <a class="back-button" (click)="backClicked()">
      <span>
        <i class="pi pi-angle-left"></i>
      </span>
    </a>
    <span class="routeName">{{ routeName }}</span>
  </div>
  <div *ngIf="!notificationPages.includes(href) && isServiceWorkerSupported" class="user-notification">
    <a class="logout" (click)="initiateLogoutProcess()" title="Logout">
      <i class="csx-arrows_logout"></i>
    </a>
    <i [ngClass]="onlineStatus" class="csx-device_wifi mobileSignal"></i>
    <a class="user" [ngClass]="{ proxyHeader: proxiedUser !== 'None' }">
      <span>{{ appUser }}</span>
      <div *ngIf="proxiedUser !== 'None'">Proxy - {{proxiedUser}}</div>
    </a>
    <user-notification [hidden]="!login"></user-notification>
    <div *ngIf="showOuatageAndProxy()" class="icon-wrapper">
      <i class="pi pi-ellipsis-v" (click)="menu.toggle($event)"></i>
      <div class="p-menu-outage">
        <p-menu #menu [popup]="true" [model]="authorityMenu" (click)="onClickAuthorityMenu($event)"></p-menu>
      </div>
    </div>
  </div>
</div>
<div class="header-dialog-model" *ngIf="showLogoutWarning">
  <p-dialog [(visible)]="showLogoutWarning" [modal]="true" [responsive]="true" [minY]="70" [maximizable]="true"
    [baseZIndex]="10000" [resizable]="false" [showHeader]="false" (onHide)="allowLogout(false)">
    Warning: Logging out will clear your offline session, this will prevent any operations from persisting and you will
    be unable
    to login untill you go online.
    <p-footer>
      <button type="button" pButton (click)="allowLogout(true)" label="Continue"></button>
      <button type="button" pButton (click)="allowLogout(false)" label="Cancel" class="p-button-outlined"></button>
    </p-footer>
  </p-dialog>
</div>
<div class="header-dialog-model" *ngIf="showProxy">

  <p-dialog class="proxy dialog-content" [modal]="true" [responsive]="true" [minY]="70" [maximizable]="false"
    [baseZIndex]="10000" [resizable]="false" [showHeader]="false" [(visible)]="showProxy">
    <div>
      <label>Current Proxy :</label> {{proxiedUser}}
    </div>
    <div class="proxy-wrapper mt-2 mb-4">
      <label>Enter Proxy :</label>
      <input type="text" placeholder="Update Racf" [(ngModel)]="userId" (ngModelChange)="userId = userId.toUpperCase()"
        maxlength="5" />
      <div *ngIf="proxyErrorMessage !== undefined">
        <p class="error-text">{{proxyErrorMessage}}</p>
      </div>
    </div>
    <div class="p-footer flex justify-content-end pt-3 gap-2 border-top-1 text-gray-200">
      <button type="button" pButton (click)="closeProxy()" label="Cancel" class="p-button-outlined"></button>
      <button type="button" pButton (click)="proxyUser()" label="Proxy"></button>
    </div>
  </p-dialog>
</div>

<div class="header-dialog-model outage" *ngIf="showOutageScreen">
  <p-dialog [(visible)]="showOutageScreen" [modal]="true" class="header-dialog-model outage" [responsive]="true"
    [maximizable]="false" [baseZIndex]="10000" [resizable]="false" header="Manage Outage">
    <div *ngIf="!isRegularMaintenance" class="proxy-wrapper outage">
      <label>Reason for Creating Outage :</label>
      <textarea rows="4" cols="60%" maxlength="250" [(ngModel)]="outageComment" required></textarea>
      <div *ngIf="outageErrorMessage !== undefined">
        <p class="error-text">{{outageErrorMessage}}</p>
      </div>
    </div>
    <div *ngIf="isRegularMaintenance"> <label>Do you want to clear Regular Maintenace Outage?</label></div>
    <p-footer>
      <button *ngIf="!isRegularMaintenance" type="button" pButton (click)="raiseOutage()" label="Raise Outage"></button>
      <button *ngIf="isRegularMaintenance" type="button" pButton (click)="clearOutage()" label="Clear Outage"></button>
      <button type="button" pButton (click)="closeOuatgeScreen()" label="Cancel" class="p-button-outlined"></button>
    </p-footer>
  </p-dialog>
</div>